<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Pencil } from 'lucide-vue-next';
</script>

<template>
    <Button
        variant="edit"
        size="xs"
    >
        <span><slot /></span>
        <Pencil class="size-3" />
    </Button>
</template>
